import React from 'react';
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import {  Form } from "react-bootstrap";
import "../../containers/ControlMeasures/ControlMeasures.css";
import DatePickerComponent from "../../components/UI/DatePicker/DatepickerComponent";
import ModalComponent from "../../components/UI/Modal/Modal";

const unosDatumaDostave = props => {

  
return (
<>

<ModalComponent
          size="m"
          show={props.modalDatDostave}
          onHide={props.hideModalUnosDatDostave}
          title="Unos datuma dostave rješenja subjektu"
        >
          <div className="row justify-content-center" key={"form"}>
            <div className="align-self-center">
              <Form onSubmit={props.submitHandlerDatDostaveRjesenja}>
               
              <div className="datepicker-modal" style = {{ marginBottom:"20px"}}>
                 <DatePickerComponent
                  required
                  errorBorderColor={
                    props.error && !props.datPreuzimanja && "red"
                  }
                  id="datPreuzimanja"
                  handleDayClick={props.datePickerHandlerDD}
                  controlLabel={"Datum dostave rješenja subjektu"}
                  //selectedDays={props.datBrisanja}
                  index={{ id: "datPreuzimanja" }}
                  width={"100%"}/>
              </div>

                <div className="row" key={"button"}>
                  <div className="col-md-6">
                    <ButtonComponent
                      type="submit"
                      block={true}
                      variant="primary"
                    // onClick={props.hideModalUnosDatBrisanja}
                    >
                      Spremi
                    </ButtonComponent>
                  </div>
                  <div className="col-md-6">
                    <ButtonComponent
                      onClick={props.hideModalUnosDatDostave}
                      block={true}
                      variant="danger"
                      style={{marginRight:"7px"}}
                    
                    >
                    Odustani 
                    </ButtonComponent>
                  </div>
                </div>
           
              </Form>
            </div>
          </div>
        </ModalComponent>
</>
)};

export default unosDatumaDostave;